import { useContext, useEffect, useRef, useState } from "react";
import { ConstantAPISContext } from "../../../../context/ConstantAPISContext";
import { showToast } from "../../../../helpers/ToastifyHelper";
import { Form, Formik } from "formik";
import { FormControl, InputLabel, MenuItem, Select, TextField, CircularProgress } from "@mui/material";
import SearchComponent from "../../../../components/OB/SearchComponent";
import KatiAtikBeyanAPI from "../../../../apis/OB/Get/KatiAtikBeyanAPI";
import TableComponent2 from "../../../../components/OB/TableComponent2";
import CaddeSokakAPI from "../../../../apis/OB/Get/CaddeSokakAPI";
import KatExportPdfAPI from "../../../../apis/OB/Rapor/KatExportPdfAPI";
import { openFileInNewTab } from "../../../../helpers/openFileNewTab";
import { today } from "../../../../helpers/TodayDate";
import KatBorcKontrolAPI from "../../../../apis/OB/Get/KatBorcKontrolAPI";
import SessionStorageService from "../../../../services/StorageService";

const KatiAtikBeyan = (props: any) => {

    const columns = [
        { header: "", field: "", className: "text-center", beyan: 1 },
        { header: "Adres", field: "adres", className: "text-center" },
        { header: "Pafta/Ada/Parsel", field: "paftaAdaParsel", className: "text-center" },
        { header: "Araç Plaka", field: "aracPlaka", className: "text-center" },
        { header: "Faaliyeti", field: "faaliyeti", className: "text-center" },
        { header: "Kullanımı", field: "kullanimi", className: "text-center" },
        { header: "Hisse Oranı", field: "hisseOran", className: "text-center" },
        { header: "Kriteri", field: "kriteri", className: "text-center" },
        { header: "Grup/ Derece", field: "grupDerece", className: "text-center" },
        { header: "Mük. Başlama Tarihi", field: "mukBaslamaTarihi", className: "text-center" },
        { header: "Kul. Başlama Tarihi", field: "kullanimaBaslamaTarihi", className: "text-center" },
        { header: "Beyan Kabul Tarihi", field: "beyanKabulTarihi", className: "text-center" },
        { header: "Mükellefiyet Bitiş Tarihi", field: "mukBitisTarihi", className: "text-center" },
        { header: "K. Sıra No", field: "kSiraNo", className: "text-center" },
    ];

    // Borç Kontrol ve Beyan Sureti İşlemi Pdf
    const exportKatSuret = (sqId: string) => {
        KatExportPdfAPI.geExportPdfListe(sqId)
            .then((res) => {
                if (res.data !== null) {
                    openFileInNewTab(
                        res.data.reportUrlByteFormat,
                        "-Katı Atık Sureti - " + today + ".pdf"
                    );
                } else {
                    showToast("Pdf indirilirken bir hata oluştu", "error");
                }
            })
            .catch((err) => {
                showToast("Pdf indirilirken bir hata oluştu", "error");

            });
    };
    const borcKontrol = (sqId: number, durum: number) => {
        KatBorcKontrolAPI.getKatBorcKontrol(sqId, durum)
            .then((res) => {

                res.data[0].sonuc == 1 ? showToast("Borç kaydınız bulunmamaktadır", "info") : exportKatSuret(sqId.toString());
            })
            .catch((err) => {
                showToast("İşleminizi şuan gerçekleştiremiyoruz.", "warning");
            });
    };

    let user = SessionStorageService.getUserInfo();

    const [data, setData] = useState<any[]>([]);

    const [searchControl, setSearchControl] = useState<boolean>(true);
    const { yilListe, mahalleListe } = useContext(ConstantAPISContext);
    const [selectedYear, setSelectedYear] = useState(Number(new Date().getFullYear()));
    const [selectedMahalleKodu, setSelectedMahalleKodu] = useState<any>();
    const [selectedCaddeSokakKodu, setSelectedCaddeSokakKodu] = useState<any>(undefined);
    const [caddeSokakDatas, setCaddeSokakDatas] = useState<any[]>([]);
    const [aktifPasif, setAktifPasif] = useState<number>(1);
    const [ada, setAda] = useState<any>(undefined);
    const [parsel, setParsel] = useState<any>(undefined);
    const [isLoading, setisLoading] = useState<boolean>(false);

    //CaddeSokakAPI
    useEffect(() => {
        if (
            selectedMahalleKodu !== undefined &&
            !Number.isNaN(selectedMahalleKodu)
        ) {
            CaddeSokakAPI.getCaddeSokakListe(undefined, selectedMahalleKodu)
                .then((res) => {
                    setCaddeSokakDatas(res.data);
                })
                .catch((err) => {
                });
        }
    }, [selectedMahalleKodu]);

    //KatiAtikBeyanAPI
    useEffect(() => {
        fetchData(false);
    }, [])

    const fetchData = async (isPass: boolean = true) => {
        setisLoading(true);
        const response = await KatiAtikBeyanAPI.getKatiAtikBeyanListe(
            user?.sicilKodu,
            selectedYear,
            aktifPasif,
            ada || null,
            parsel || null,
            selectedMahalleKodu || null,
            selectedCaddeSokakKodu || null,
        )
        setData(response.data);
        setTimeout(() => {
            setisLoading(false);

        }, 100)
        setSearchControl(true)
        if (response.data.length < 1)
            showToast("Kayıt Bulunamadı!", "warning");
    }

    const handleTemizle = () => {
        setSelectedYear(Number(new Date().getFullYear()));
        setSelectedCaddeSokakKodu(undefined)
        setSelectedMahalleKodu(undefined)
        setAktifPasif(1)
        setAda(undefined)
        setParsel(undefined)
    }

    //Formik constantları
    const initialValues = {
        //boş kalacak ihtiyaca göre kullanılabilir
    };
    return (
        <div className="px-1 pt-1">
            <Formik
                initialValues={initialValues}
                onSubmit={() => { }}>
                <Form id="kayit-form" className="d-flex w-100 mb-4">
                    <div className="d-flex flex-column flex-sm-row w-100 gap-3 ml-2 mr-2">
                        <div className="d-flex flex-column flex-sm-row gap-2 w-100">
                            <FormControl size="small"
                                sx={{
                                    width: {
                                        xs: "100%",
                                        sm: "50%",
                                        md: "25%",
                                    },
                                    minWidth: 140
                                }}>

                                <InputLabel id="">Yıl</InputLabel>
                                <Select
                                    sx={{
                                        backgroundColor: "white"
                                    }}
                                    labelId=""
                                    id=""
                                    name="yil"
                                    label="yil"
                                    error={selectedYear == undefined && searchControl == false ? true : false}

                                    value={selectedYear || ""}
                                    onChange={(e) => {
                                        setSelectedYear(Number(e.target.value || undefined));
                                    }}                                >
                                    {yilListe.map((item) => (
                                        <MenuItem
                                            key={item}
                                            value={item.yili}                                            >
                                            {item.yili}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl size="small"
                                sx={{
                                    width: {
                                        xs: "100%",
                                        sm: "50%",
                                        md: "25%",
                                    },
                                    minWidth: 140
                                }}>

                                <InputLabel id=""></InputLabel>
                                <Select
                                    sx={{
                                        backgroundColor: "white"
                                    }}
                                    labelId=""
                                    id=""
                                    label=""
                                    value={aktifPasif || ""}
                                    onChange={(e) => {
                                        setAktifPasif(Number(e.target.value));
                                    }}
                                >
                                    <MenuItem selected value={1}>{"Aktif"}</MenuItem>
                                    <MenuItem value={2}>{"Pasif"}</MenuItem>
                                    <MenuItem value={3}>{"Hepsi"}</MenuItem>
                                </Select>
                            </FormControl>
                            <FormControl size="small"
                                sx={{
                                    width: {
                                        xs: "100%",
                                        sm: "50%",
                                        md: "25%",
                                    },
                                    minWidth: 140
                                }}>

                                <InputLabel id="">Mahalle</InputLabel>
                                <Select
                                    sx={{
                                        backgroundColor: "white"
                                    }}
                                    labelId=""
                                    id=""
                                    error={selectedMahalleKodu == undefined && searchControl == false ? true : false}
                                    value={selectedMahalleKodu || ""}
                                    label="Mahalle"
                                    onChange={(e) => {
                                        setSelectedMahalleKodu(Number(e.target.value || undefined));
                                        setSelectedCaddeSokakKodu(undefined)
                                    }}
                                >
                                    {mahalleListe.map((item) => (
                                        <MenuItem
                                            key={item}
                                            value={item.mahalleKodu}                                            >
                                            {item.mahalleAdi}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl size="small"
                                sx={{
                                    width: {
                                        xs: "100%",
                                        sm: "50%",
                                        md: "25%",
                                    },
                                    minWidth: 140
                                }}>

                                <InputLabel id="">Cadde/Sokak</InputLabel>
                                <Select
                                    sx={{
                                        backgroundColor: "white"
                                    }}
                                    labelId=""
                                    id=""
                                    value={selectedCaddeSokakKodu || ""}
                                    label="Cadde/Sokak"
                                    onChange={(e) => {
                                        setSelectedCaddeSokakKodu(Number(e.target.value || undefined));
                                    }}
                                >
                                    {caddeSokakDatas.map((item) => (
                                        <MenuItem
                                            key={item}
                                            value={item.caddeSokakKodu}                                            >
                                            {item.caddeSokakAdi}
                                        </MenuItem>
                                    ))}

                                </Select>
                            </FormControl>
                            <FormControl size="small"
                                sx={{
                                    width: {
                                        xs: "100%",
                                        sm: "50%",
                                        md: "25%",
                                    },
                                    minWidth: 140
                                }}>

                                <TextField id="" label="Ada" variant="outlined" size="small"
                                    value={ada || ""}
                                    onChange={(event) => event.target.value === "" ? setAda("") : event.target.value.match(/^[0-9]+$/) ? setAda(event.target.value.substring(0, 10)) : null}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            backgroundColor: 'white', // Arka plan rengini beyaz yapar
                                        },
                                    }}
                                />
                            </FormControl>
                            <div className="form-group w-100  align-self-center">
                                <FormControl size="small"
                                    sx={{
                                        width: {
                                            xs: "100%",
                                            sm: "50%",
                                            md: "25%",
                                        },
                                        minWidth: 140
                                    }}>

                                    <TextField id="" label="Parsel" variant="outlined" size="small"
                                        value={parsel || ""}
                                        onChange={(event) => event.target.value === "" ? setParsel("") : event.target.value.match(/^[0-9]+$/) ? setParsel(event.target.value.substring(0, 10)) : null}
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                backgroundColor: 'white', // Arka plan rengini beyaz yapar
                                            },
                                        }}
                                    />
                                </FormControl>
                            </div>
                        </div>
                        <div className="d-flex  flex-row ms-auto ">
                            <SearchComponent
                                fetchData={fetchData}
                                onTemizle={handleTemizle}
                                setData={setData} />
                        </div>
                    </div>
                </Form>
            </Formik>
            {isLoading ?
                <div className="d-flex w-100 justify-content-center align-items-center" style={{ height: '10rem' }}>

                    <CircularProgress />
                </div>
                :
                <TableComponent2 columns={columns} data={data} recordsPerPage={5} borcKontrol={borcKontrol}></TableComponent2>
            }
        </div >
    )
}

export default KatiAtikBeyan;